'use client'

import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import {
  ShieldAlert,
  Lock,
  Factory,
  Printer,
  ExternalLink
} from 'lucide-react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

// Define the admin routes
const adminRoutes = [
  { href: '/admin', label: 'Admin', icon: Lock },
  { href: '/admin/operator', label: 'Operator', icon: Factory },
  { href: '/print', label: 'Printer', icon: Printer }
]

export function AdminNavFloat() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    // Check for auth token in localStorage
    const hasAuthToken = typeof window !== 'undefined' && Boolean(localStorage.getItem('auth_token'))
    setIsAuthenticated(hasAuthToken)
  }, [])

  // If no auth token exists, don't render anything
  if (!isAuthenticated) {
    return null
  }

  return (
    <div className="fixed bottom-[4.5rem] right-4 z-50">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button
            size="icon"
            className="h-10 w-10 border rounded-full shadow-lg bg-background border-accent-foreground hover:bg-accent/10"
          >
            <ShieldAlert className="h-5 w-5 text-accent-foreground" />
            <span className="sr-only">Admin Navigation</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-[240px] sm:w-[300px]">
          <SheetHeader className="pb-4">
            <SheetTitle className="text-lg font-medium">Admin Portal</SheetTitle>
          </SheetHeader>
          <div className="py-4">
            <nav className="grid gap-2">
              {adminRoutes.map((route) => {
                const Icon = route.icon
                const isActive = pathname.startsWith(route.href)
                return (
                  <Link
                    key={route.href}
                    href={route.href}
                    onClick={() => setIsOpen(false)}
                    className={`
                      flex items-center gap-3 px-4 py-2.5 rounded-md
                      transition-colors duration-200
                      ${isActive ? 'bg-accent text-accent-foreground font-medium' : 'text-muted-foreground hover:text-foreground hover:bg-muted'}
                    `}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{route.label}</span>
                    {isActive ? null : <ExternalLink className="h-3.5 w-3.5 ml-auto opacity-60" />}
                  </Link>
                )
              })}
            </nav>
          </div>
          <div className="pt-6 mt-auto text-xs text-muted-foreground">
            <p>Administrative access only</p>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  )
}

export default AdminNavFloat
